<template>
    <Loader v-if="loading" />
    <DataTable :value="items" :sortOrder="-1" sortField="data_creazione" paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50]" breakpoint="1190px">
      <template #header>
          <div class="flex flex-wrap align-items-center justify-content-between gap-2">
            <div>
              <Button icon="pi pi-refresh" class="m-2" @click="getActivePratiche()"/>
            </div>
          </div>
        </template>
  
      <template #empty>
        <div class="text-center">Nessun dato</div>
      </template>
      <Column field="filename" header="File di richiesta">
        <template #body="{data}">
          <Button :label="data.filename" v-if="!data.id_richiesta" style="font-size: 10px; max-width: fit-content;" v-tooltip="'Scarica file di richiesta'" @click="downloadFilePratica(data.filename)" icon="pi pi-download" severity="info"/>
          <p v-else>
            {{ data.filename}}
          </p>
        </template>
      </Column>
      <Column field="total" header="Numero righe">
        <template #body="{data}">
          <p v-tooltip="`${data.codes}`">{{ data.total }}</p>
        </template>
      </Column>
      <Column field='data_creazione' header="Data Creazione" :sortable="true">
        <template #body="{data}">
          {{moment(data.data_creazione).format('DD-MM-YYYY HH:mm')}}
        </template>
      </Column>
      <Column field="ID richiesta" header="ID richiesta">
        <template #body="{data, index}">
          <InputMask v-if="data.id_richiesta == null" v-model="id_pratica[index]" mask="9999999" style="max-width: 5rem;"/>
          <p v-else> {{ data.id_richiesta }} </p>
        </template>
  
      </Column>
      <Column field='processed' header="Completo">
        <template #body="{data}">
          <span v-if="data.processed">
            <i class="pi pi-check text-green-400" style="font-size: 1rem"></i>
          </span>
          <span v-else>
            <i class="pi pi-ban p-error" style="font-size: 1rem"></i>
          </span>
        </template>
      </Column>
      <Column field='data_elaborazione' header="Data Elaborazione" :sortable="true">
        <template #body="{data}">
          {{data.data_elaborazione ? moment(data.data_elaborazione).format('DD-MM-YYYY HH:mm') : '--'}}
        </template>
      </Column>
  
      <Column :exportable="false">
        <template #body="{data, index}">
          <FileUpload style="font-size: 10px; max-width: fit-content;" v-if="!data.processed && data.id_richiesta" mode="basic" :auto="true" accept=".csv" customUpload @uploader="uploadResponse($event, data.id_richiesta, 'pk', data.filename.startsWith('PKG1') ? 'Gas' : 'Energia')" chooseLabel="Carica Esito" />
          <!-- <Button style="font-size: 10px; max-width: fit-content;" v-if="data.processed" label="Scarica esito" icon="pi pi-cloud-download" @click="downloadResponsePrecheckFile($event, data.id_richiesta, data.filename.startsWith('PKG1') ? 'Gas' : 'Energia')" severity="success"/> -->
          <Button style="font-size: 10px; max-width: fit-content;" v-if="!data.id_richiesta && (id_pratica[index] != null && id_pratica[index] != '')" icon="pi pi-link" label="Salva l'ID della richiesta" :disabled="id_pratica[index] == ''" @click="saveIdPratica(data.filename, id_pratica[index], index)"/>
        </template>
      </Column>
    </DataTable>
  </template>
  
  <script>
  import {ref, onMounted, getCurrentInstance } from 'vue';
  import Loader from "@/components/Loader.vue"
  import Service from '@/services/ask-pratiche/pratiche-wizard'
  import moment from 'moment'
  var CSV = require("xlsx");
  import { useToast } from "primevue/usetoast";
     
  export default {
    components: {
      Loader,
    },
    
    setup () { 
      const toast = useToast();
      const loading = ref(false)
      const activeTabIndex = ref(0)
      const activeTabIndexMethod = ref(0)
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      const service = new Service(self.$eventBus)
      const filename = ref('')
      const types = ref([
        {name:'ee', description: 'Energia'},
        {name:'gas', description: 'Gas'}
      ]);
      const allowedType = {
        'csv' : 'csv'
      }
  
      const fileUpload = ref()
      const headingsPK = ["COD_SERVIZIO", "COD_FLUSSO", "PIVA_VENDITORE", "PIVA_GESTORE", "CP_VENDITORE", "CP_GESTORE", "VERIFICA_AMM", "COD_CAUSALE", "MOTIVAZIONE", "ESITO", "COD_ESITO", "DETTAGLIO_ESITO", "COD_POD", "CF", "PIVA", "CF_STRANIERO", "DATA_SALVAGUARDIA", "CRPP_MM_F1", "CRPP_MM_F2", "CRPP_MM_F3", "CRPP_MM1_F1", "CRPP_MM1_F2", "CRPP_MM1_F3", "RISOLUZIONE_CONTRATTUALE_TIMOE", "PIVA_CONTROPARTE_COMMERCIALE", "RAG_SOC_CONTR_COMM", "EMAIL_CONTR_COMM", "PMA_POD"]
      const headingsPKG = ["COD_SERVIZIO", "COD_FLUSSO", "PIVA_VENDITORE", "PIVA_GESTORE", "CP_VENDITORE", "CP_GESTORE", "VERIFICA_AMM", "COD_CAUSALE", "MOTIVAZIONE", "ESITO", "COD_ESITO", "DETTAGLIO_ESITO", "COD_PDR", "COD_REMI", "TIPO_PDR", "PIVA_DISTRIBUTORE", "CF", "PIVA", "CF_STRANIERO", "NOME", "COGNOME", "RAGIONE_SOCIALE_DENOMINAZIONE", "RAGIONE_SOCIALE_CONTROPARTECOMMERCIALE", "PIVA_CONTROPARTECOMMERCIALE", "POSTA_CERTIFICATA"]
      const id_pratica = ref([])
  
      const items = ref()
      const ids_richiesta = ref([])
  
      const submitted = ref(false)
  
      onMounted(() => { 
        loading.value = true
        const promises = [
          getActivePratiche()
        ]
        Promise.all(promises).finally(()=>{
          loading.value = false
        })
      })
  
      const getActivePratiche = async (swo = true) => {
        items.value = []
        ids_richiesta.value = []
        loading.value = true
        let year = (new Date()).getFullYear()
  
        await service.getPratiche(swo).then((res)=>{
          res.items.forEach(pratica => {
            ids_richiesta.value.push(pratica.id_richiesta)
            let index = pratica.filename.indexOf(year);
            pratica.type_file = pratica.filename.substring(0, index);
          });
          items.value = res.items.filter(el => /^(PK)/.test(el.filename))
        })
        .finally(()=>{
          loading.value = false
        })
      }
     
      const saveIdPratica = (file, id, index) => {
        loading.value = true
  
        if (ids_richiesta.value.includes(id)) {
          loading.value = false
          toast.add({severity:'warn', summary:'Associazione non riuscita', detail: `ID di Richiesta già utilizzato`, life: 10000});
          
          delete id_pratica.value[index]
         
          return
        }
  
        let severity = 'success'
        let summary = 'Associazione eseguita'
        let detail = `${file} è stato associato all'id ${id_pratica.value[index]}`
  
        service.saveIdPratica(file, id_pratica.value[index])
        .then((res)=>{
          loading.value = false
          if (!res) {
            severity = 'warn'
            summary = 'Associazione non riuscita'
            detail = `${file} non è stato associato all'id ${id_pratica.value[index]}`
          }
          toast.add({severity:severity, summary:summary, detail: detail, life: 10000});
        })
        .finally(()=>{
          delete id_pratica.value[index]
          getActivePratiche()
        })
      }
  
      const uploadResponse = async (event, id, type_file, supply, swo = true) => {
        submitted.value = true
        let filename = event.files[0].name.replace('risposte_','')
        let id_file = filename.replace('.csv','')
  
        if (id_file == id) {
          fileUpload.value = event.files[0]
          console.log(fileUpload.value);
          
          if (await validateFile(fileUpload.value, supply == 'Energia' ? 'PK1' : 'PKG1')) {
            loading.value = true
            service.uploadPraticaFile([fileUpload.value], id, type_file, supply, swo)
            .then((res) => {
              if (res) {
                toast.add({severity:'success', summary:'Importazione eseguita', detail: `Elaborazione del file di risposta eseguita correttamente`, life: 10000});
              } else {
                toast.add({severity:'warn', summary:'Importazione fallita', detail: `Elaborazione del file di risposta non riuscita`, life: 10000});
              }
              fileUpload.value = null
            })
            .finally(() => {
              getActivePratiche()
              loading.value = false
            })
          }
        }else{
          toast.add({severity:'warn', summary:'Importazione fallita', detail: `Il file di risposta inserito non corrisponde alla richiesta selezionata`, life: 10000});
        }
      }
  
      const downloadFilePratica = async (file) => {
        loading.value = true
        await service.downloadFileName(file)
        .finally(()=> {
          getActivePratiche()
          loading.value = false
        })
      }
      
      const validateFile = async (file, type_file)  => {        
        let type_headings
        switch (type_file) {
            case 'PK1':
            type_headings = headingsPK
            break;
            case 'PKG1':
            type_headings = headingsPKG
            break;
        }
        const data = await file.arrayBuffer();
        const workbook = CSV.read(data);
        let first_sheet_name = workbook.SheetNames[0];
        let ws = workbook.Sheets[first_sheet_name];
        let headers = (CSV.utils.sheet_to_json(ws, { header: 1 }))[0];

        if (type_file != 'PKG1' && !headers.includes("PMA_POD")) {
            headers.push("PMA_POD")
        }
        const isSameHeaders = JSON.stringify(headers) === JSON.stringify(type_headings);

        if (!isSameHeaders) {
            toast.add({severity:'warn', summary:'Importazione fallita', detail: `Il file di risposta inserito non è conforme con la richiesta selezionata`});
            
            return false
        }else{
            return true
        }
    }

  
      return {
        loading,
        activeTabIndex,
        activeTabIndexMethod,
        allowedType,
        uploadResponse,
        downloadFilePratica,
        types,
        filename,
        id_pratica,
        saveIdPratica,
        getActivePratiche,
        items,
        moment,
      }
    },
  }
  </script>
  
  <style scoped>
  .p-card{
    min-width: 335px !important;
  }
  .btn-red, .btn-red:hover{
    color: #ffffff;
    background: #d32f2f;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    border-radius: 3px;
    border: 1px solid #2196F3;
  }
  .form-file .button-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 250px;
    border: 2px dashed rgba(156, 156, 156, 0.577);
    border-radius: 5px;
    text-align: center;
    justify-content: center;
    display: flex;
    align-items: center;
  }
  
  .form-file .allowed-format {
    font-size: 12px;
    color: rgb(186, 186, 186);
    margin-top: 2px;
  }
  
  .form-file .button-wrapper span.label {
    position: relative;
    z-index: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 250px;
    background: #ffffff;
    cursor: pointer;
    color: rgb(168, 168, 168);
    padding: 10px 2px;
    text-transform:uppercase;
    font-size:12px;
    border-radius: 3px;
    box-shadow: none;
  }
  
  .form-file .remove-file {
      color: red;
      margin-top:15px;
      cursor: pointer;
      text-align: center;
      text-transform: uppercase;
      font-size: 12px;
  }
  
  .form-file .button-wrapper span.label.active {
    color: #2196F3;
  }
  
  #uploadIV, #uploadPK {
      display: inline-block;
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      cursor: pointer;
  }
  .btn-download{
    width: 173px;
  }
  </style>
  